"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft } from "@instadeepai/fontawesome-pro-regular"

import { Button } from "@shared/ui"

export function ForgeLayoutHeader() {
  const pathname = usePathname()
  const pathSegments = pathname.split("/")
  const pathSegmentsLength = pathSegments.length
  const parentPath = pathSegments.slice(0, -1).join("/")
  const excludeBackButtonPaths = ["custom-forge", "forging-progress"]
  const currentPath = pathSegments[pathSegmentsLength - 1] || ""
  const routeDepth = pathSegmentsLength > 2
  const shouldShowBackButton =
    routeDepth && !excludeBackButtonPaths.includes(currentPath)

  return (
    <div className="flex items-center justify-between px-8">
      <h1 className="grow text-[30px] font-semibold leading-[38px] text-gray-900">
        Forge
      </h1>
      {shouldShowBackButton && (
        <Link href={parentPath}>
          <Button
            variant="secondary"
            leftIcon={<FontAwesomeIcon icon={faChevronLeft} />}
          >
            Back
          </Button>
        </Link>
      )}
    </div>
  )
}
